import { DatePipe, NgStyle, NgClass, NgIf, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { AdminService } from '../admin.service';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../../shared/pipes/sort-by-filter.pipe';
@Component({
    selector: 'app-show-bulletin-full-report',
    templateUrl: './show-bulletin-full-report.component.html',
    styleUrls: ['./show-bulletin-full-report.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgStyle,
        NgClass,
        NgIf,
        NgFor,
        NgxPaginationModule,
        DatePipe,
        SearchFilterPipe,
        SortByFilterPipe,
    ],
})
export class ShowBulletinFullReportComponent implements OnInit {

  search4users: string;
  errorMessage: string;
  makeName: string = 'BMW';
  public p;
  priorDays: string;
  APP_SETTINGS: any;
  fullReportData: any[];
  isDesc = false;
  column = '';
  direction: number;
  public searchRating;
  constructor(private spinnerService: SpinnerService, public date: DatePipe,
    private adminService: AdminService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.priorDays = "";
    this.errorMessage = "";
    this.adminService.getBulletinFullRatingReport(this.makeName, this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.fullReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.errorMessage = error.error.message;
      console.error('Error retrieving bulleting rating report');
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });
  }
  getPriorDaysReport() {
    this.errorMessage = "";
    this.adminService.getBulletinFullRatingReport(this.makeName, this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.fullReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.fullReportData = [];
      this.errorMessage = error.error.message;
      console.error('Error retrieving bulleting rating report');
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });
  }

  downloadExcel() {
    this.spinnerService.show('bmwSpinner');
    this.adminService.downloadFullStarReportExcel(this.makeName, this.priorDays).subscribe(data => {
      if (data) {
        const fileURL = URL.createObjectURL(data);
        this.spinnerService.hide('bmwSpinner');
        window.open(fileURL, '_blank');
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      });
  }

  getFullReportByMakeName() {
    this.adminService.getBulletinFullRatingReport(this.makeName, this.priorDays).subscribe(reportData => {
      this.spinnerService.hide('bmwSpinner');
      this.fullReportData = reportData;
      this.cdr.markForCheck();
    }, error => {
      this.errorMessage = error.error.message;
      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });

  }

  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction    
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }

  pageNumChange(event) {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

}
